import fullClient from 'algoliasearch'
import algoliasearch from 'algoliasearch/lite'
import qs from 'qs'
import { ParsedUrlQuery } from 'querystring'
import * as R from 'ramda'
import type { Locale } from './types'
const appId = process.env.NEXT_PUBLIC_ALGOLIA_APPLICATION_ID!
const apiKey = process.env.NEXT_PUBLIC_ALGOLIA_API_KEY!
const secureApiKey = process.env.ALGOLIA_API_KEY!
const { config } = require('./../commerce/config')
const { defaultLocale } = config

export const SearchClient = algoliasearch(appId, apiKey)
export const secureSearchClient = algoliasearch(appId, secureApiKey)
export const algoliaClient = fullClient(appId, secureApiKey)
export const getFilterAttributeTitle = (attribute: string) => {
  const title = attribute
  if (attribute === 'named_tags.category') return 'Categories'
  if (attribute === 'colourHandle') return 'Colour'
  return title?.replace('named_tags.', '')?.replace('_', ' ')?.toLowerCase()
}

export const searchStateToURL = (
  searchState: any,
  page?: number,
  scrollPosition?: number
) => {
  const selectiveState: any = {}
  Object.keys(searchState).forEach((key) => {
    if (key === 'refinementList') {
      const refinements = R.reject(R.equals(''))(searchState[key])
      if (Object.keys(refinements).length) selectiveState[key] = refinements
    } else if (key === 'p' && searchState[key] > 1) {
      selectiveState[key] = searchState[key]
    } else if (key === 'q') {
      selectiveState[key] = searchState[key]
    }
  })

  if (scrollPosition && scrollPosition > 500)
    selectiveState['position'] = scrollPosition

  return Object.keys(selectiveState).length
    ? `?${qs.stringify(selectiveState)}`
    : ''
}
export const debounceTime = 700
export const pathToSearchState = (path: string) =>
  path.includes('?') ? qs.parse(path.substring(path.indexOf('?') + 1)) : {}
export default SearchClient

export const hasColourQuery = (query: ParsedUrlQuery) => {
  if (Object.keys(query)?.some((key) => key.includes('colour'))) {
    return true
  }
  return false
}

export const getDefaultSearchString = (searchString?: string) => {
  if (!searchString) return `NOT named_tags.search:hidden`

  return `${searchString} AND NOT named_tags.search:hidden`
}

export const getDefaultSearchStringForGeneralDocs = (
  locale?: Locale | string,
  showPrivate?: boolean,
  showB2B?: boolean
) => {
  const typeFilter = showPrivate
    ? showB2B
      ? `(type:general OR type:article OR type:private OR type:b2b)`
      : `(type:general OR type:article OR type:private)`
    : showB2B
    ? `(type:general OR type:article OR type:b2b)`
    : `(type:general OR type:article)`
  if (!locale) return `${typeFilter} AND lang:${defaultLocale}`
  if (
    locale === defaultLocale ||
    locale === 'de-eu' ||
    locale === 'es-eu' ||
    locale === 'es-us'
  )
    return `${typeFilter} AND lang:${locale}`
  return `${typeFilter} AND (lang:${locale} OR lang:${defaultLocale})`
}

export const checkIfSearchTermIsValid = (
  searchTerm: String,
  locale: Locale
) => {
  if (locale === 'en-au' || locale === 'en-uk' || locale === 'en-gb') {
    return searchTerm.match(
      /^[a-zA-Z0-9\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/
    )
  }
  return true
}
